export default __webpack_public_path__ + "img/form.8a5b2c4cc71de2cb0765bb18fedd8c3d.png";